export default class AllNotesService {
    _notes = []

    constructor() {
        this.initializeNotes();
    }
    initializeNotes() {
        let notes = [
            {n:'E', s:6, f:0},
            {n:'F', s:6, f:1},
            {n:'F#/Gb', s:6, f:2},
            {n:'G', s:6, f:3},
            {n:'G#/Ab', s:6, f:4},
            {n:'A', s:6, f:5},
            {n:'A#/Bb', s:6, f:6},
            {n:'B/Cb', s:6, f:7},
            {n:'C', s:6, f:8},
            {n:'C#/Db', s:6, f:9},
            {n:'D', s:6, f:10},
            {n:'D#/Eb', s:6, f:11},
            {n:'E', s:6, f:12},
            {n:'F', s:6, f:13},
            {n:'F#/Gb', s:6, f:14},
            {n:'G', s:6, f:15},
            {n:'G#/Ab', s:6, f:16},
            {n:'A', s:6, f:17},
            {n:'A#/Bb', s:6, f:18},
            {n:'B/Cb', s:6, f:19},
            {n:'C', s:6, f:20},
            {n:'C#/Db', s:6, f:21},
            {n:'D', s:6, f:22},
            {n:'A', s:5, f:0},
            {n:'A#/Bb', s:5, f:1},
            {n:'B/Cb', s:5, f:2},
            {n:'C', s:5, f:3},
            {n:'C#/Db', s:5, f:4},
            {n:'D', s:5, f:5},
            {n:'D#/Eb', s:5, f:6},
            {n:'E', s:5, f:7},
            {n:'F', s:5, f:8},
            {n:'F#/Gb', s:5, f:9},
            {n:'G', s:5, f:10},
            {n:'G#/Ab', s:5, f:11},
            {n:'A', s:5, f:12},
            {n:'A#/Bb', s:5, f:13},
            {n:'B/Cb', s:5, f:14},
            {n:'C', s:5, f:15},
            {n:'C#/Db', s:5, f:16},
            {n:'D', s:5, f:17},
            {n:'D#/Eb', s:5, f:18},
            {n:'E', s:5, f:19},
            {n:'F', s:5, f:20},
            {n:'F#/Gb', s:5, f:21},
            {n:'G', s:5, f:22},
            {n:'D', s:4, f:0},
            {n:'D#/Eb', s:4, f:1},
            {n:'E', s:4, f:2},
            {n:'F', s:4, f:3},
            {n:'F#/Gb', s:4, f:4},
            {n:'G', s:4, f:5},
            {n:'G#/Ab', s:4, f:6},
            {n:'A', s:4, f:7},
            {n:'A#/Bb', s:4, f:8},
            {n:'B/Cb', s:4, f:9},
            {n:'C', s:4, f:10},
            {n:'C#/Db', s:4, f:11},
            {n:'D', s:4, f:12},
            {n:'D#/Eb', s:4, f:13},
            {n:'E', s:4, f:14},
            {n:'F', s:4, f:15},
            {n:'F#/Gb', s:4, f:16},
            {n:'G', s:4, f:17},
            {n:'G#/Ab', s:4, f:18},
            {n:'A', s:4, f:19},
            {n:'A#/Bb', s:4, f:20},
            {n:'B/Cb', s:4, f:21},
            {n:'C', s:4, f:22},
            {n:'G', s:3, f:0},
            {n:'G#/Ab', s:3, f:1},
            {n:'A', s:3, f:2},
            {n:'A#/Bb', s:3, f:3},
            {n:'B/Cb', s:3, f:4},
            {n:'C', s:3, f:5},
            {n:'C#/Db', s:3, f:6},
            {n:'D', s:3, f:7},
            {n:'D#/Eb', s:3, f:8},
            {n:'E', s:3, f:9},
            {n:'F', s:3, f:10},
            {n:'F#/Gb', s:3, f:11},
            {n:'G', s:3, f:12},
            {n:'G#/Ab', s:3, f:13},
            {n:'A', s:3, f:14},
            {n:'A#/Bb', s:3, f:15},
            {n:'B/Cb', s:3, f:16},
            {n:'C', s:3, f:17},
            {n:'C#/Db', s:3, f:18},
            {n:'D', s:3, f:19},
            {n:'D#/Eb', s:3, f:20},
            {n:'E', s:3, f:21},
            {n:'F', s:3, f:22},
            {n:'B/Cb', s:2, f:0},
            {n:'C', s:2, f:1},
            {n:'C#/Db', s:2, f:2},
            {n:'D', s:2, f:3},
            {n:'D#/Eb', s:2, f:4},
            {n:'E', s:2, f:5},
            {n:'F', s:2, f:6},
            {n:'F#/Gb', s:2, f:7},
            {n:'G', s:2, f:8},
            {n:'G#/Ab', s:2, f:9},
            {n:'A', s:2, f:10},
            {n:'A#/Bb', s:2, f:11},
            {n:'B/Cb', s:2, f:12},
            {n:'C', s:2, f:13},
            {n:'C#/Db', s:2, f:14},
            {n:'D', s:2, f:15},
            {n:'D#/Eb', s:2, f:16},
            {n:'E', s:2, f:17},
            {n:'F', s:2, f:18},
            {n:'F#/Gb', s:2, f:19},
            {n:'G', s:2, f:20},
            {n:'G#/Ab', s:2, f:21},
            {n:'A', s:2, f:22},
            {n:'E', s:1, f:0},
            {n:'F', s:1, f:1},
            {n:'F#/Gb', s:1, f:2},
            {n:'G', s:1, f:3},
            {n:'G#/Ab', s:1, f:4},
            {n:'A', s:1, f:5},
            {n:'A#/Bb', s:1, f:6},
            {n:'B/Cb', s:1, f:7},
            {n:'C', s:1, f:8},
            {n:'C#/Db', s:1, f:9},
            {n:'D', s:1, f:10},
            {n:'D#/Eb', s:1, f:11},
            {n:'E', s:1, f:12},
            {n:'F', s:1, f:13},
            {n:'F#/Gb', s:1, f:14},
            {n:'G', s:1, f:15},
            {n:'G#/Ab', s:1, f:16},
            {n:'A', s:1, f:17},
            {n:'A#/Bb', s:1, f:18},
            {n:'B/Cb', s:1, f:19},
            {n:'C', s:1, f:20},
            {n:'C#/Db', s:1, f:21},
            {n:'D', s:1, f:22}]
        this._notes = notes
    }

    isHalfStep(startNote, endNote) {
        for(var i=0; i<this._notes.length-1; i++) {
            let note = this._notes[i].n;
            let noteArray = note.split("/");
            for(var j =0; j<noteArray.length; j++) {
                if(startNote===noteArray[j]) {
                    let nextNote = this._notes[i+1].n
                    let nextNoteArray = nextNote.split("/")
                    for(var k=0; k<nextNoteArray.length; k++) {
                        if(nextNoteArray[k]===endNote) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        }
    }
    getFretData(notes, fretStart, fretEnd) {
        let selectedNotes = []
        for (var i = 0; i < this._notes.length; i++) {
            for(var j=0; j<notes.length; j++) {
                let fret = this._notes[i].f
                if(fret>= fretStart && fret<=fretEnd) {
                    let subArray = this._notes[i].n.split('/');
                    for(var k=0; k<subArray.length; k++) {
                        if(subArray[k] === notes[j]) {
                            selectedNotes.push(this._notes[i])
                        }
                    }
                }
            }
        }
        return selectedNotes;
    }
}
